<h1 mat-dialog-title>{{ 'scheduler.setup.skillProfiles.single' | translate }} Add</h1>

<!--<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>-->
<!--<mat-card *ngIf="isError">-->
<!--<mat-card-header>-->
<!--{{errorMessage| translate}}-->
<!--</mat-card-header>-->
<!--<mat-card-actions>-->
<!--<button mat-button (click)="retryLoad()">{{ 'scheduler.general.retry' | translate }}</button>-->
<!--</mat-card-actions>-->
<!--</mat-card>-->

<form (ngSubmit)="addSkillProfile()" [formGroup]="skillProfileForm">

  <mat-icon color="accent">description</mat-icon>
  <mat-form-field>
    <input formControlName="skillProfileNameFC" matInput required type="text">
    <mat-label>Name</mat-label>
    @if (skillProfileForm.controls['skillProfileNameFC']) {
      <mat-error>Please enter name !</mat-error>
    }
  </mat-form-field>

  <mat-dialog-actions>
    <span class="spacer"></span>
    <button (click)="onCancelClick()" mat-flat-button type="reset">{{ 'scheduler.general.cancel' | translate }}</button>
    <button [disabled]="!skillProfileForm.valid" color="primary" mat-raised-button type="submit">Add</button>
  </mat-dialog-actions>
</form>